module.exports = require("npm:object-fit-images@3.2.4/dist/ofi.common-js.js");